import { render } from "./ProductAddonsList.vue?vue&type=template&id=3bfa84d0&scoped=true"
import script from "./ProductAddonsList.vue?vue&type=script&lang=ts"
export * from "./ProductAddonsList.vue?vue&type=script&lang=ts"

import "./ProductAddonsList.vue?vue&type=style&index=0&id=3bfa84d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3bfa84d0"

export default script